import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import ESTADOS_MEXICO from "../estadosMexico";
import { NIVELES_INTERES } from "./interes";

function ProspectosCreate() {
  const { user } = useContext(AuthContext);
  const URL_CRM_PROSPECTOS = process.env.REACT_APP_URL_CRM_PROSPECTOS;
  const URL_CRM_CATEGORIAS = process.env.REACT_APP_URL_CRM_CATEGORIAS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_MAQUINAS = process.env.REACT_APP_URL_MAQUINAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const [razon_social, setRazonSocial] = useState("");
  const [contacto, setContacto] = useState("");
  const [cargo, setCargo] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [RFC, setRFC] = useState("");
  const [origen, setOrigen] = useState("Web");
  const [interes, setInteres] = useState("");
  const [estado, setEstado] = useState("");
  const [categorias, setCategorias] = useState([]);
  const [categoriasSel, setCategoriasSel] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [articulosSel, setArticulosSel] = useState([]);
  const [buscarArticulo, setBuscarArticulo] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [responsable, setResponsable] = useState("");
  const [maquinas, setMaquinas] = useState([]);
  const [maquinasSel, setMaquinasSel] = useState([]);
  const [valor_estimado, setValorEstimado] = useState(0);
  const [notas, setNotas] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    axios.get(URL_CRM_CATEGORIAS, headers).then((r) => setCategorias(r.data)).catch((e) => console.log(e));
    axios.get(URL_COLABORADORES, headers).then((r) => setUsuarios(r.data)).catch((e) => console.log(e));
    axios.get(URL_ARTICULOS, headers).then((r) => setArticulos(r.data)).catch((e) => console.log(e));
    axios.get(URL_MAQUINAS, headers).then((r) => setMaquinas(r.data)).catch((e) => console.log(e));
  }, []);

  function toggleMaquina(id) {
    setMaquinasSel((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  }

  function toggleCategoria(id) {
    setCategoriasSel((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  }

  // Activos + los ya seleccionados, filtrados por el buscador (codigo o descripcion).
  const articulosFiltrados = articulos
    .filter((a) => a.is_active === "Si" || articulosSel.includes(a._id))
    .filter((a) => {
      if (!buscarArticulo) return true;
      const s = buscarArticulo.toLowerCase();
      return (
        (a.descripcion || "").toLowerCase().includes(s) ||
        (a.codigo || "").toString().toLowerCase().includes(s)
      );
    })
    .sort((a, b) => (a.descripcion > b.descripcion ? 1 : -1));

  function toggleArticulo(id) {
    setArticulosSel((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  }

  const saveProspecto = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    const fecha_alta = new Date().toISOString().split("T")[0];
    axios
      .post(
        URL_CRM_PROSPECTOS,
        {
          razon_social,
          contacto,
          cargo,
          email,
          telefono,
          whatsapp,
          empresa,
          RFC,
          origen,
          interes,
          estado,
          categorias: categoriasSel,
          articulosInteres: articulosSel,
          maquinas: maquinasSel,
          responsable,
          valor_estimado: Number(valor_estimado) || 0,
          notas,
          fecha_alta,
          usuarioNombre: user.nombre,
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          { tipo: "Crear Prospecto", detalle: razon_social, user: user.id },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        Swal.fire("Good job!", "Prospecto creado con exito", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        setValidaBoton(true);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response ? error.response.data : error}`,
        });
      });
  };

  return (
    <Form onSubmit={saveProspecto}>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>Nombre / Razon social *</Label>
            <Input
              type="text"
              value={razon_social}
              required
              onChange={(e) => setRazonSocial(e.target.value)}
            />
          </FormGroup>
        </Col>

            <Col md={6}>
              <Label>Estado (República)</Label>
              <Input type="select" value={estado} onChange={(e) => setEstado(e.target.value)}>
                <option value="">Selecciona...</option>
                {ESTADOS_MEXICO.map((es) => (
                  <option key={es} value={es}>{es}</option>
                ))}
              </Input>
            </Col>
        {/* <Col md={6}>
          <FormGroup>
            <Label>Empresa</Label>
            <Input type="text" value={empresa} onChange={(e) => setEmpresa(e.target.value)} />
          </FormGroup>
        </Col> */}
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>Persona de contacto</Label>
            <Input type="text" value={contacto} onChange={(e) => setContacto(e.target.value)} />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Cargo</Label>
            <Input type="text" value={cargo} onChange={(e) => setCargo(e.target.value)} />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup>
            <Label>Email</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Telefono *</Label>
            <Input
              type="text"
              value={telefono}
              required
              onChange={(e) => setTelefono(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>WhatsApp</Label>
            <Input type="text" value={whatsapp} onChange={(e) => setWhatsapp(e.target.value)} />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup>
            <Label>RFC</Label>
            <Input type="text" value={RFC} onChange={(e) => setRFC(e.target.value)} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Origen del lead</Label>
            <Input type="select" value={origen} onChange={(e) => setOrigen(e.target.value)}>
              <option value="Web">Web</option>
              <option value="Referido">Referido</option>
              <option value="Llamada en frio">Llamada en frio</option>
              <option value="Feria">Feria / Expo</option>
                <option value="Recuperacion de Cliente">Recuperacion de Cliente</option>
              <option value="Redes sociales">Redes sociales</option>
              <option value="Recomendacion">Recomendacion</option>
                <option value="ClienteActual">Cliente Actual</option>
              <option value="Otro">Otro</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Interés</Label>
            <Input type="select" value={interes} onChange={(e) => setInteres(e.target.value)}>
              <option value="">Sin definir</option>
              {NIVELES_INTERES.map((n) => (
                <option key={n._id} value={n._id}>{n.etiqueta}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>Responsable (vendedor)</Label>
            <Input type="select" value={responsable} onChange={(e) => setResponsable(e.target.value)}>
              <option value="">Sin asignar</option>
              {usuarios.map((u) => (
                <option key={u._id} value={u._id}>{u.nombre} {u.apellido}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Valor estimado ($)</Label>
            <Input type="number" value={valor_estimado} onChange={(e) => setValorEstimado(e.target.value)} />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <FormGroup>
            <Label>Máquinas (opcional)</Label>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
                gap: "2px 12px",
                border: "1px solid #e2e8f0",
                borderRadius: 6,
                padding: 8,
              }}
            >
              {maquinas.length === 0 ? (
                <small className="text-muted">Sin máquinas. Créalas en Catálogos → Máquinas.</small>
              ) : (
                maquinas
                  .filter((m) => m.is_active !== "No")
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((m) => (
                    <div key={m._id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "2px 0" }}>
                      <input
                        type="checkbox"
                        checked={maquinasSel.includes(m._id)}
                        onChange={() => toggleMaquina(m._id)}
                        style={{ width: 15, height: 15, margin: 0, flexShrink: 0 }}
                      />
                      <span>{m.nombre}</span>
                    </div>
                  ))
              )}
            </div>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <FormGroup>
            <Label>Categorías</Label>
            {/* En columnas para que quepan todas sin scroll. */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(170px, 1fr))",
                gap: "2px 12px",
                border: "1px solid #e2e8f0",
                borderRadius: 6,
                padding: 8,
              }}
            >
              {categorias.length === 0 ? (
                <small className="text-muted">Sin categorías. Créalas en CRM → Categorías.</small>
              ) : (
                categorias.map((c) => (
                  <div key={c._id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "2px 0" }}>
                    <input
                      type="checkbox"
                      checked={categoriasSel.includes(c._id)}
                      onChange={() => toggleCategoria(c._id)}
                      style={{ width: 15, height: 15, margin: 0, flexShrink: 0 }}
                    />
                    <span>{c.nombre}</span>
                  </div>
                ))
              )}
            </div>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <FormGroup>
            <Label>Artículos de interés (opcional)</Label>
            <Input
              type="text"
              placeholder="Buscar artículo..."
              value={buscarArticulo}
              onChange={(e) => setBuscarArticulo(e.target.value)}
              style={{ marginBottom: 8 }}
            />
            <div style={{ height: 260, overflowY: "auto", border: "1px solid #e2e8f0", borderRadius: 6, padding: 8 }}>
              {articulosFiltrados.length === 0 ? (
                <small className="text-muted">Sin artículos que coincidan.</small>
              ) : (
                articulosFiltrados.map((a) => (
                  <div key={a._id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "2px 0" }}>
                    <input
                      type="checkbox"
                      checked={articulosSel.includes(a._id)}
                      onChange={() => toggleArticulo(a._id)}
                      style={{ width: 15, height: 15, margin: 0, flexShrink: 0 }}
                    />
                    <span>{a.codigo ? `${a.codigo} / ` : ""}{a.descripcion}</span>
                  </div>
                ))
              )}
            </div>
            {articulosSel.length > 0 && (
              <small className="text-muted">{articulosSel.length} artículo(s) seleccionado(s)</small>
            )}
          </FormGroup>
        </Col>
      </Row>
      <FormGroup>
        <Label>Notas</Label>
        <Input type="textarea" value={notas} onChange={(e) => setNotas(e.target.value)} />
      </FormGroup>
      <div className="submit-bar">
        <Button type="submit" className="btn btn-success" disabled={!validaBoton}>
          <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
        </Button>
      </div>
    </Form>
  );
}

export default ProspectosCreate;
